'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimArrayPrototypeIncludes() {
	var polyfill = getPolyfill();
	if (Array.prototype.includes !== polyfill) {
		define(Array.prototype, { includes: polyfill });
	}
	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/array-includes/3.0.2/array-includes/shim.js
 ** module id = 647
 ** module chunks = 0
 **/